import { Component, OnInit } from '@angular/core';

import { TranslatePipe } from '../../pipes/translate.pipe';
import { LanguageSelectorComponent } from '../../components/language-selector/language-selector.component';
import { ThemeSelectorComponent } from '../../components/theme-selector/theme-selector.component';
import { ThemePackageSelectorComponent } from '../../components/theme-package-selector/theme-package-selector.component';
import { AuthService, User } from '../../services/auth.service';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    TranslatePipe,
    LanguageSelectorComponent,
    ThemeSelectorComponent,
    ThemePackageSelectorComponent
],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  currentUser: User | null = null;

  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    this.authService.currentUser$.subscribe(user => {
      this.currentUser = user;
    });
  }
}
